if (!customElements.get('shibumi-rest-landing-v03')) {
  customElements.define('shibumi-rest-landing-v03', class extends HTMLElement {
    connectedCallback() {
      this.purchase = this.querySelector('[data-rest-purchase]');
      this.planInput = this.querySelector('[data-rest-selling-plan]');
      this.planSelect = this.querySelector('[data-rest-plan-select]');

      this.querySelectorAll('[data-rest-purchase-type]').forEach((input) => {
        input.addEventListener('change', () => {
          const subscription = input.value === 'subscription';
          if (this.planInput) {
            this.planInput.disabled = !subscription;
            if (subscription) this.planInput.value = this.planSelect?.value || this.planInput.dataset.default;
          }
          if (this.planSelect) this.planSelect.disabled = !subscription;
          this.querySelectorAll('.srv3-plan').forEach((plan) => plan.classList.toggle('is-selected', plan.contains(input)));
        });
      });

      this.planSelect?.addEventListener('change', () => { this.planInput.value = this.planSelect.value; });
      this.querySelectorAll('[data-rest-submit]').forEach((button) => button.addEventListener('click', () => {
        const input = this.querySelector(`[data-rest-purchase-type][value="${button.dataset.restSubmit}"]`);
        if (input && !input.checked) { input.checked = true; input.dispatchEvent(new Event('change', { bubbles: true })); }
      }));
      this.querySelectorAll('[data-rest-scroll]').forEach((button) => button.addEventListener('click', () => {
        this.purchase?.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
      }));
    }
  });
}
